import { useEffect } from 'react'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import Link from '@mui/material/Link'
import HelmetMeta from '../../layouts/HelmetMeta'
import OtherPagesHeader from '../Others/OtherPagesHeader'
import { useTranslation } from 'react-i18next'

export default function Groups () {
  const { t } = useTranslation('social')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container sx={{ mb: 6 }} maxWidth='xl' disableGutters>
      <HelmetMeta
        {...{
        title: t('groups.metaTitle'),
        description: t('groups.metaDescription'),
        image: '/img/peaks-social.jpg'
      }}
      />
      <Box sx={{ position: 'relative' }}>
        <OtherPagesHeader
          {...{
          ratio: 1.765,
          image: 'https://d1hi0tbu2kom2c.cloudfront.net/img/peaks-social.jpg',
          title: t('groups.headerTitle'),
          subtitle: t('groups.headerSubtitle'),
          titleFontSize: { xs: '1.3rem', md: '1.7rem' },
          subtitleFontSize: { xs: '1rem', sm: '1.15rem' }
        }}
        />
      </Box>
      <Box
        sx={{
        mx: 2
      }}
      >
        <Box
          sx={{
            my: 4,
            textAlign: 'center'
          }}
        >
          <Button
            component={Link}
            target='_blank'
            href='https://chat.whatsapp.com/G2oaTgOJLVx0XHd61KcbBR'
            startIcon={<WhatsAppIcon />}
            variant='outlined'
            sx={{ color: 'white', mt: 2, '&:hover': { color: '#ddd' } }}
          >
            {t('groups.joinWhatsappCommunity')}
          </Button>
        </Box>

        <Typography>
          {t('groups.intro')} {t('groups.ready')}
        </Typography><br />
        <Typography>
          {t('groups.outro')}
        </Typography><br />
      </Box>
    </Container>
  )
}
